<template>
  <div v-if="!loading" class="box">
    <div class="images">
      <img
        class="img"
        :src="url">
    </div>
  </div>
  <Loading v-else :loading="loading"/>
</template>

<script>

import Loading from '../../../components/Loading'
import { getPushPoster } from '../../../api/api'
export default {
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      url: '',
      isPc: true,
      id: this.$route.params.id
    }
  },
  mounted () {
    const _this = this
    _this.loading = true
    // window.addEventListener('scroll', _this.handleScroll, true)
    _this.id = _this.$route.params.id
    _this.getPushimage()
    // console.log('宽度', document.documentElement.clientWidth)
    _this.clientHeight = document.documentElement.clientHeight
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setRight({
        show: false // 控制按钮显 示， true 显示， false 隐藏， 默认true
      })
    }
  },
  methods: {
    async getPushimage () {
      try {
        const res = await getPushPoster({
          file_id: this.id
        })
        if (res.code === 200) {
          this.url = res.data.url
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
  .box {
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    font-size: 0;
    .images {
      width: 100vw;
      height: 100vh;
      overflow: auto;
      .img {
        width: 100vw;
        // min-height: 100vh;
      }
    }
  }
</style>
